module.exports = __webpack_public_path__ + "media/customizations/onvie/logo-7e72db21ec3b1a4966a128c1f5af8f2a.png";